(() => {
  if (window.__productLinkedSwatchesCollectionLoaded) return;
  window.__productLinkedSwatchesCollectionLoaded = true;

  const CARD_SELECTOR = '[data-product-swatches-card]';

  const escapeHtml = (value) => {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  };

  const normalize = (value) => {
    return String(value || '').trim().toLowerCase();
  };

  const getColorBackground = (
    colors,
    style = 'line'
  ) => {
    if (!Array.isArray(colors) || !colors.length) {
      return '#f3f3f3';
    }

    if (colors.length === 1) {
      return colors[0];
    }

    const segmentSize = 100 / colors.length;

    const stops = colors.flatMap(
      (color, index) => {
        const start = segmentSize * index;
        const end = segmentSize * (index + 1);

        return [
          `${color} ${start}%`,
          `${color} ${end}%`
        ];
      }
    );

    if (style === 'conic') {
      return `conic-gradient(from -90deg, ${stops.join(', ')})`;
    }

    return colors[0];
  };

  const isMobileViewport = () => {
    return window.matchMedia(
      '(max-width: 749px)'
    ).matches;
  };

  const renderSwatchHtml = (swatch) => {
    if (!swatch) return '';

    if (swatch.image) {
      return `
        <span
          class="
            product-form__swatch
            product-form__swatch--image
          "
          aria-hidden="true"
        >
          <img
            src="${escapeHtml(swatch.image)}"
            alt=""
            width="48"
            height="48"
            loading="lazy"
          >
        </span>
      `;
    }

    if (
      swatch.style === 'conic' &&
      Array.isArray(swatch.colors) &&
      swatch.colors.length
    ) {
      return `
        <span
          class="
            product-form__swatch
            product-form__swatch--color
            product-form__swatch--conic
          "
          style="
            --swatch-background:
            ${escapeHtml(
              getColorBackground(
                swatch.colors,
                swatch.style
              )
            )};
          "
          aria-hidden="true"
        ></span>
      `;
    }

    const segments = (swatch.colors || [])
      .map(
        (color) => `
          <span
            class="product-form__swatch-segment"
            style="background: ${escapeHtml(color)};"
          ></span>
        `
      )
      .join('');

    return `
      <span
        class="
          product-form__swatch
          product-form__swatch--color
          product-form__swatch--line
        "
        aria-hidden="true"
      >
        ${segments}
      </span>
    `;
  };

  const mergeVendorGroups = (groups) => {
    const vendorGroups = (groups || [])
      .filter(
        (group) =>
          group.valueSource === 'vendor' &&
          group.showOnCard
      );

    if (!vendorGroups.length) {
      return null;
    }

    const merged = {
      ...vendorGroups[0],
      valueSource: 'vendor',
      swatches: []
    };

    const swatchesByLabel = new Map();

    vendorGroups.forEach((group) => {
      (group.swatches || []).forEach(
        (swatch) => {
          swatchesByLabel.set(
            normalize(swatch.label),
            swatch
          );
        }
      );
    });

    merged.swatches = [
      ...swatchesByLabel.values()
    ];

    return merged;
  };

  const getCardContext = (card) => {
    return {
      id: String(
        card.getAttribute(
          'data-product-id'
        ) || ''
      ).trim(),
      title: String(
        card.getAttribute(
          'data-product-title'
        ) || ''
      ).trim(),
      vendor: String(
        card.getAttribute(
          'data-product-vendor'
        ) || ''
      ).trim(),
      url: String(
        card.getAttribute(
          'data-product-url'
        ) || ''
      ).trim()
    };
  };

  const isCurrentProduct = (
    product,
    current
  ) => {
    if (!product || !current) return false;

    if (
      current.id &&
      String(product.id) ===
        String(current.id)
    ) {
      return true;
    }

    return (
      normalize(product.vendor) ===
      normalize(current.vendor)
    );
  };

  const getRenderablePartners = (
    partners,
    group,
    current
  ) => {
    const items = (partners || [])
      .map((product) => {
        const swatch =
          window.ProductSwatches
            .getSwatchForValue(
              group,
              product.vendor
            );

        if (!swatch) return null;

        return {
          product,
          swatch,
          active: isCurrentProduct(
            product,
            current
          )
        };
      })
      .filter(Boolean);

    items.sort((a, b) => {
      if (a.active && !b.active) return -1;
      if (!a.active && b.active) return 1;
      return 0;
    });

    return items;
  };

  const getCardRoot = (card) => {
    return (
      card.closest('[data-product-item]') ||
      card.closest('.product')
    );
  };

  const getCardImage = (card) => {
    const root = getCardRoot(card);

    if (!root) return null;

    return (
      root.querySelector(
        '.product-card-figure img:first-of-type'
      ) ||
      root.querySelector('figure img')
    );
  };

  const storeOriginalCardImage = (image) => {
    if (
      !image ||
      image.dataset.productSwatchOriginalStored ===
        'true'
    ) {
      return;
    }

    image.dataset.productSwatchOriginalStored =
      'true';

    image.dataset.productSwatchOriginalSrc =
      image.getAttribute('src') || '';

    image.dataset.productSwatchOriginalSrcset =
      image.getAttribute('srcset') || '';

    image.dataset.productSwatchOriginalTemplate =
      image.getAttribute('data-rimg-template') || '';

    image.dataset.productSwatchOriginalMax =
      image.getAttribute('data-rimg-max') || '';
  };

  const previewCardImage = (
    card,
    product
  ) => {
    if (!product?.image) return;

    const image = getCardImage(card);

    if (!image) return;

    storeOriginalCardImage(image);

    image.setAttribute(
      'src',
      product.image
    );

    image.removeAttribute('srcset');

    if (
      image.hasAttribute(
        'data-rimg-template'
      )
    ) {
      image.removeAttribute(
        'data-rimg-template'
      );
    }
  };

  const restoreCardImage = (card) => {
    const image = getCardImage(card);

    if (
      !image ||
      image.dataset.productSwatchOriginalStored !==
        'true'
    ) {
      return;
    }

    const src =
      image.dataset.productSwatchOriginalSrc;

    const srcset =
      image.dataset.productSwatchOriginalSrcset;

    const template =
      image.dataset.productSwatchOriginalTemplate;

    const max =
      image.dataset.productSwatchOriginalMax;

    if (src) {
      image.setAttribute('src', src);
    }

    if (srcset) {
      image.setAttribute(
        'srcset',
        srcset
      );
    } else {
      image.removeAttribute('srcset');
    }

    if (template) {
      image.setAttribute(
        'data-rimg-template',
        template
      );
    }

    if (max) {
      image.setAttribute(
        'data-rimg-max',
        max
      );
    }
  };

  const setCardHovering = (
    card,
    hovering
  ) => {
    const root = getCardRoot(card);

    if (!root) return;

    root.classList.toggle(
      'card-swatches-hovering',
      hovering
    );
  };

  const renderCard = (
    card,
    partners,
    group
  ) => {
    const current =
      getCardContext(card);

    const list = card.querySelector(
      '[data-product-swatches-list]'
    );

    if (!list) return;

    const items =
      getRenderablePartners(
        partners,
        group,
        current
      );

    if (!items.length) {
      list.innerHTML = '';

      card.setAttribute(
        'data-card-product-swatches-empty',
        'true'
      );

      card.classList.remove(
        'is-loading'
      );

      card.dataset.productSwatchesReady =
        'true';

      return;
    }

    card.removeAttribute(
      'data-card-product-swatches-empty'
    );

    const isMobile = isMobileViewport();

    const swatchSize = isMobile
      ? (group.collectionSwatchSizeMobile ?? group.collectionSwatchSize ?? 34)
      : (group.collectionSwatchSize ?? 34);

    const limit = isMobile
      ? (group.collectionSwatchLimitMobile ?? group.collectionSwatchLimit ?? 4)
      : (group.collectionSwatchLimit ?? 5);

    card.style.setProperty(
      '--card-product-swatch-size',
      `${swatchSize}px`
    );

    const visible =
      items.slice(0, limit);

    const remainder =
      Math.max(
        0,
        items.length - visible.length
      );

    list.innerHTML = `
      ${visible
        .map(({ product, swatch, active }) => {
          const vendor =
            escapeHtml(product.vendor);

          return `
            <a
              href="${escapeHtml(product.url)}"
              class="
                card-product-swatches__item
                ${active ? 'is-active' : ''}
              "
              data-card-linked-product-swatch
              data-product-id="${escapeHtml(product.id)}"
              data-product-vendor="${vendor}"
              aria-label="${vendor}"
              title="${vendor}"
              ${active ? 'aria-current="page"' : ''}
            >
              ${renderSwatchHtml(swatch)}
              <span class="visually-hidden">
                ${vendor}
              </span>
            </a>
          `;
        })
        .join('')}
      ${
        remainder > 0
          ? `
            <a
              class="card-product-swatches__more"
              href="${escapeHtml(current.url)}"
              aria-label="${remainder} more options"
            >
              +${remainder}
            </a>
          `
          : ''
      }
    `;

    list
      .querySelectorAll(
        '[data-card-linked-product-swatch]'
      )
      .forEach((anchor, index) => {
        const item = visible[index];

        anchor.addEventListener(
          'mouseenter',
          () => {
            setCardHovering(
              card,
              true
            );

            previewCardImage(
              card,
              item.product
            );
          }
        );

        anchor.addEventListener(
          'mouseleave',
          () => {
            restoreCardImage(card);

            setCardHovering(
              card,
              false
            );
          }
        );

        anchor.addEventListener(
          'focus',
          () => {
            setCardHovering(
              card,
              true
            );

            previewCardImage(
              card,
              item.product
            );
          }
        );

        anchor.addEventListener(
          'blur',
          () => {
            restoreCardImage(card);

            setCardHovering(
              card,
              false
            );
          }
        );
      });

    card.classList.remove(
      'is-loading'
    );

    card.dataset.productSwatchesReady =
      'true';
  };

  const getPendingCards = (
    root = document
  ) => {
    const cards = [];

    if (
      root instanceof Element &&
      root.matches(CARD_SELECTOR)
    ) {
      cards.push(root);
    }

    if (
      root.querySelectorAll
    ) {
      cards.push(
        ...root.querySelectorAll(
          CARD_SELECTOR
        )
      );
    }

    return cards.filter((card) => {
      return (
        card.dataset.productSwatchesReady !==
        'true'
      );
    });
  };

  const renderPendingCards = async (
    root = document
  ) => {
    if (!window.ProductSwatches) {
      return false;
    }

    const cards =
      getPendingCards(root);

    if (!cards.length) {
      return true;
    }

    const contexts =
      cards
        .map((card) => ({
          card,
          current:
            getCardContext(card)
        }))
        .filter(
          ({ current }) =>
            current.title
        );

    if (!contexts.length) {
      return true;
    }

    contexts.forEach(({ card }) => {
      card.classList.add(
        'is-loading'
      );
    });

    const genericGroups =
      window.ProductSwatches
        .getConfiguredGroups();

    const genericVendorGroup =
      mergeVendorGroups(
        genericGroups
      );

    if (!genericVendorGroup) {
      contexts.forEach(({ card }) => {
        card.setAttribute(
          'data-card-product-swatches-empty',
          'true'
        );

        card.classList.remove(
          'is-loading'
        );

        card.dataset.productSwatchesReady =
          'true';
      });

      return true;
    }

    const titles = contexts.map(
      ({ current }) =>
        current.title
    );

    try {
      const families =
        await window.ProductSwatches
          .getPartnerProductsForTitles(
            titles
          );

      contexts.forEach(
        ({ card, current }) => {
          const productGroups =
            window.ProductSwatches
              .getConfiguredGroups({
                productId: current.id
              });

          const group =
            mergeVendorGroups(
              productGroups
            ) ||
            genericVendorGroup;

          const partners =
            families.get(
              current.title
            ) || [];

          renderCard(
            card,
            partners,
            group
          );
        }
      );

      return true;
    } catch (error) {
      console.error(
        'Collection product swatches failed to load:',
        error
      );

      contexts.forEach(({ card }) => {
        card.classList.remove(
          'is-loading'
        );
      });

      return false;
    }
  };

  const resetCards = (
    root = document
  ) => {
    const cards = [];

    if (
      root instanceof Element &&
      root.matches(CARD_SELECTOR)
    ) {
      cards.push(root);
    }

    if (root.querySelectorAll) {
      cards.push(
        ...root.querySelectorAll(
          CARD_SELECTOR
        )
      );
    }

    cards.forEach((card) => {
      delete card.dataset
        .productSwatchesReady;
    });
  };

  const refreshCollection = (
    root = document,
    {
      force = false
    } = {}
  ) => {
    if (force) {
      resetCards(root);
    }

    return renderPendingCards(root);
  };

  let resizeTimer = null;

  window.addEventListener(
    'resize',
    () => {
      window.clearTimeout(
        resizeTimer
      );

      resizeTimer =
        window.setTimeout(() => {
          refreshCollection(
            document,
            { force: true }
          );
        }, 150);
    }
  );

  window.ProductSwatchesCollection = {
    refresh: refreshCollection,
    reset: resetCards
  };

  // Also expose it through the existing namespace.
  if (window.ProductSwatches) {
    window.ProductSwatches
      .refreshCollection =
      refreshCollection;
  }

  const boot = () => {
    refreshCollection();
  };

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      boot,
      { once: true }
    );
  } else {
    boot();
  }
})();
